module.exports = __webpack_public_path__ + "img/首页-证书2.4dca7902.jpg";